export const UPDATE_MODAL = "UPDATE_MODAL";
export const INITIALIZE_MULTI_DEVIS = "INITIALIZE_MULTI_DEVIS";
export const INITIALIZE_MULTI_DEVIS_COMPLETED =
  "INITIALIZE_MULTI_DEVIS_COMPLETED";
export const INITIALIZE_MULTI_DEVIS_FAILED = "INITIALIZE_MULTI_DEVIS_FAILED";

export const GET_BREAKFAST_PRODUCTS = "GET_BREAKFAST_PRODUCTS";
export const GET_BREAKFAST_PRODUCTS_COMPLETED = "GET_BREAKFAST_PRODUCTS_COMPLETED";
export const GET_BREAKFAST_PRODUCTS_FAILED = "GET_BREAKFAST_PRODUCTS_FAILED";

export const GET_BREAKFAST_FORMULAS = "GET_BREAKFAST_FORMULAS";
export const GET_BREAKFAST_FORMULAS_COMPLETED = "GET_BREAKFAST_FORMULAS_COMPLETED";
export const GET_BREAKFAST_FORMULAS_FAILED = "GET_BREAKFAST_FORMULAS_FAILED";

export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCTS_COMPLETED = "GET_PRODUCTS_COMPLETED";
export const GET_PRODUCTS_FAILED = "GET_PRODUCTS_FAILED";

export const GET_PRODUCT_GROUPS = "GET_PRODUCT_GROUPS";
export const GET_PRODUCT_GROUPS_COMPLETED = "GET_PRODUCT_GROUPS_COMPLETED";
export const GET_PRODUCT_GROUPS_FAILED = "GET_PRODUCT_GROUPS_FAILED";

export const GET_PRODUCT_PACKAGES = "GET_PRODUCT_PACKAGES";
export const GET_PRODUCT_PACKAGES_COMPLETED = "GET_PRODUCT_PACKAGES_COMPLETED";
export const GET_PRODUCT_PACKAGES_FAILED = "GET_PRODUCT_PACKAGES_FAILED";

export const GET_PRODUCT_CLASSIFICATIONS = "GET_PRODUCT_CLASSIFICATIONS";
export const GET_PRODUCT_CLASSIFICATIONS_COMPLETED = "GET_PRODUCT_CLASSIFICATIONS_COMPLETED";
export const GET_PRODUCT_CLASSIFICATIONS_FAILED = "GET_PRODUCT_CLASSIFICATIONS_FAILED";

export const GET_TENDERS = "GET_TENDERS";
export const GET_TENDERS_COMPLETED = "GET_TENDERS_COMPLETED";
export const GET_TENDERS_FAILED = "GET_TENDERS_FAILED";

export const GET_PRODUCT_PARTS = "GET_PRODUCT_PARTS";
export const GET_PRODUCT_PARTS_COMPLETED = "GET_PRODUCT_PARTS_COMPLETED";
export const GET_PRODUCT_PARTS_FAILED = "GET_PRODUCT_PARTS_FAILED";

export const ADD_ADDRESS = "ADD_ADDRESS";
export const ADD_ADDRESS_COMPLETED = "ADD_ADDRESS_COMPLETED";
export const ADD_ADDRESS_FAILED = "ADD_ADDRESS_FAILED";

// Briques B2B : templates de blocs pour la création/édition de devis
export const GET_BRIQUES = "GET_BRIQUES";
export const GET_BRIQUES_COMPLETED = "GET_BRIQUES_COMPLETED";
export const GET_BRIQUES_FAILED = "GET_BRIQUES_FAILED";

// Mise à jour du prix d'achat HT d'une offre (produit / groupe / forfait)
export const UPDATE_PURCHASE_PRICE = "UPDATE_PURCHASE_PRICE";
export const UPDATE_PURCHASE_PRICE_COMPLETED = "UPDATE_PURCHASE_PRICE_COMPLETED";
export const UPDATE_PURCHASE_PRICE_FAILED = "UPDATE_PURCHASE_PRICE_FAILED";

export const updateModal = (modal) => ({
  type: UPDATE_MODAL,
  payload: modal,
});

// silent = true : recharge les données sans passer isLoading à true (évite de
// démonter MultiOrders — et donc de fermer les modales ouvertes — pendant le fetch)
export const initialize = (silent = false) => ({
  type: INITIALIZE_MULTI_DEVIS,
  payload: { silent: silent },
  meta: {
    async: true,
    blocking: !silent,
    path: `/api/pro/orders/initialize.json`,
    method: "GET",
    params: {},
  },
});

export const getBreakfastProducts = () => ({
  type: GET_BREAKFAST_PRODUCTS,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/breakfasts/products.json`,
    method: "GET",
    params: {},
  },
});

export const getBreakfastFormulas = () => ({
  type: GET_BREAKFAST_FORMULAS,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/breakfasts/formulas.json`,
    method: "GET",
    params: {},
  },
});

export const getProducts = () => ({
  type: GET_PRODUCTS,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/offer/products.json`,
    method: "GET",
    params: {},
  },
});

export const getProductGroups = () => ({
  type: GET_PRODUCT_GROUPS,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/offer/productgroups.json`,
    method: "GET",
    params: {},
  },
});

export const getProductPackages = () => ({
  type: GET_PRODUCT_PACKAGES,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/offer/productpackages.json`,
    method: "GET",
    params: {},
  },
});

export const getProductClassifications = () => ({
  type: GET_PRODUCT_CLASSIFICATIONS,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/offer/productclassifications.json`,
    method: "GET",
    params: {},
  },
});

export const getProductParts = () => ({
  type: GET_PRODUCT_PARTS,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/offer/productparts.json`,
    method: "GET",
    params: {},
  },
});

export const addAddress = (addressData) => ({
  type: ADD_ADDRESS,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/addresses/add.json`,
    method: "POST",
    body: { address: addressData },
  },
});

/**
 * Charge les briques B2B depuis l'API.
 * Filtre optionnel par formatTagId pour ne charger que les briques
 * pertinentes pour le format de prestation sélectionné.
 */
/**
 * Met à jour le prix d'achat HT (centimes) d'une offre sans ouvrir la fiche.
 * @param {'product'|'group'|'forfait'} itemType
 * @param {number} id
 * @param {?number} purchasePriceHt en centimes
 */
export const updatePurchasePrice = (itemType, id, purchasePriceHt) => {
  const pathByType = {
    product: `/api/pro/offer/products/${id}.json`,
    group: `/api/pro/offer/productgroups/${id}.json`,
    forfait: `/api/pro/offer/productpackages/${id}.json`,
  };
  return {
    type: UPDATE_PURCHASE_PRICE,
    payload: { itemType, id },
    meta: {
      async: true,
      blocking: false,
      path: pathByType[itemType],
      method: "PUT",
      body: { purchase_price_ht: purchasePriceHt },
    },
  };
};

export const getBriques = (formatTagId = null) => ({
  type: GET_BRIQUES,
  meta: {
    async: true,
    blocking: false,
    path: formatTagId
      ? `/api/pro/briques.json?format_tag_id=${formatTagId}`
      : `/api/pro/briques.json`,
    method: "GET",
    params: {},
  },
});